/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online unit converter for length, weight, temperature, volume, area, speed, data and time. Fast, accurate, and works in your browser.`)
};

const es_uc_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de unidades en línea gratuito para longitud, peso, temperatura, volumen, área, velocidad, datos y tiempo. Rápido, preciso y funciona en tu navegador.`)
};

const de_uc_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Einheitenumrechner für Länge, Gewicht, Temperatur, Volumen, Fläche, Geschwindigkeit, Daten und Zeit. Schnell, präzise und direkt im Browser nutzbar.`)
};

const nl_uc_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online eenheidconverter voor lengte, gewicht, temperatuur, volume, oppervlakte, snelheid, gegevens en tijd. Snel, nauwkeurig en werkt in uw browser.`)
};

const fr_uc_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur d'unités gratuit en ligne pour longueur, poids, température, volume, superficie, vitesse, données et temps. Rapide, précis et fonctionne dans votre navigateur.`)
};

const it_uc_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di unità online gratuito per lunghezza, peso, temperatura, volume, area, velocità, dati e tempo. Veloce, accurato e funziona nel tuo browser.`)
};

const pt_br2_uc_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de unidades online gratuito para comprimento, peso, temperatura, volume, área, velocidade, dados e tempo. Rápido, preciso e funciona no seu navegador.`)
};

const pt_uc_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de unidades online gratuito para comprimento, peso, temperatura, volume, área, velocidade, dados e tempo. Rápido, preciso e funciona no seu navegador.`)
};

const ja_uc_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長さ、質量、温度、体積、面積、速度、データ、時間のための無料オンラインユニットコンバーター。高速で正確で、ブラウザで動作します。`)
};

const zh_uc_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_hub_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_hub_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_hub_meta_description", locale)
	if (locale === "en") return en_uc_hub_meta_description(inputs)
	if (locale === "es") return es_uc_hub_meta_description(inputs)
	if (locale === "de") return de_uc_hub_meta_description(inputs)
	if (locale === "nl") return nl_uc_hub_meta_description(inputs)
	if (locale === "fr") return fr_uc_hub_meta_description(inputs)
	if (locale === "it") return it_uc_hub_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_uc_hub_meta_description(inputs)
	if (locale === "pt") return pt_uc_hub_meta_description(inputs)
	if (locale === "ja") return ja_uc_hub_meta_description(inputs)
	return zh_uc_hub_meta_description(inputs)
};